<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<RevolvingPutOptionTable v-if="activeTab === tabTypes.currentRequests" @changed="updateCounts"/>
		<RevolvingPutOptionActiveTable v-if="activeTab === tabTypes.activeOptions" @changed="updateCounts"/>
		<RevolvingPutOptionContractOverviewTable v-if="activeTab === tabTypes.contractsOverview" @changed="updateCounts"/>
	</div>
</template>
<script>

import RevolvingPutOptionTable from "@/components/templates/seller/putOption/RevolvingPutOptionTable";
import RevolvingPutOptionActiveTable from "@/components/templates/seller/putOption/RevolvingPutOptionActiveTable";
import RevolvingPutOptionContractOverviewTable
	from "@/components/templates/seller/putOption/RevolvingPutOptionContractOverviewTable";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {revolvingPutOptionsSellerApi} from "@/common/api/revolvingPutOptionsSellerApi";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
	components: { RevolvingPutOptionActiveTable, AccessRestrictedTabs, RevolvingPutOptionTable, RevolvingPutOptionContractOverviewTable },
	data() {
		let tabTypes = {
			currentRequests: {
				name: navigationTabs.seller.putOptions.requests,
				translationKey: "revolvingPutOption.currentRequests.tab",
				permission: enumDef.permissions.SellerRevolvingPutOptions
			},
			activeOptions: {
				name: navigationTabs.seller.putOptions.active,
				translationKey: "revolvingPutOption.activeOptions.tab",
				permission: enumDef.permissions.SellerRevolvingPutOptions,
				count: null
			},
			contractsOverview: {
				name: navigationTabs.seller.putOptions.contracts,
				translationKey: "revolvingPutOption.contractsOverview.tab",
				permission: enumDef.permissions.SellerRevolvingPutOptions
			}
		};

		return {
			tabTypes: tabTypes,
			activeTab: null,
		};
	},
	created() {
		this.updateCounts();
	},
	methods: {
		updateCounts() {
			revolvingPutOptionsSellerApi.inspection.getCounts()
				.then(counts => {
					this.tabTypes.activeOptions.count = counts.activeCount;
				});
		}
	},
};
</script>